import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import { theme } from '@/theme'
// Mantine Core Styles - Granular imports for critical performance
import '@mantine/core/styles/global.css';
import '@mantine/core/styles/default-css-variables.css';
import '@mantine/core/styles/baseline.css';
import '@mantine/core/styles/Typography.css';
import '@mantine/core/styles/UnstyledButton.css';
import '@mantine/core/styles/VisuallyHidden.css';

// Layout essentials (Must load before components)
import '@mantine/core/styles/Container.css';
import '@mantine/core/styles/Group.css';
import '@mantine/core/styles/Stack.css';

// Critical UI Components for Hero/Header
import '@mantine/core/styles/Text.css';
import '@mantine/core/styles/Title.css';
import '@mantine/core/styles/Paper.css';
import '@mantine/core/styles/Badge.css';
import '@mantine/core/styles/Button.css';
import '@mantine/core/styles/Burger.css';

// Global Styles (Critical for background and utility classes)
import '@/index.css';

// Modal and Drawer dependencies (Removed from critical CSS, lazy loaded on mobile nav)

// Note: Most other Mantine styles and the main index.css are deferred 
// or imported in components to reduce the critical render-path weight.

import App from '@/App'
import { RuntimeGate } from '@/components/runtime/RuntimeGate'

import { BrowserRouter } from 'react-router-dom'




// Defer Service Worker registration to optimize LCP & FCP (Removes it from Critical Request Chain)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Wait for idle or small delay for absolute safety on busy main threads
    const timeout = 'requestIdleCallback' in window ? 2000 : 0;
    setTimeout(() => {
        navigator.serviceWorker.register('/sw.js', { scope: '/' })
            .catch(error => console.error('SW registration failed:', error));
    }, timeout);
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="dark">
      <RuntimeGate>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </RuntimeGate>
    </MantineProvider>
  </StrictMode>,
)

